class CartService {
    /*@ngInject*/
    constructor($q, $resource, $cookies, $window, accountService) {
        this.$q = $q;
        this.$resource = $resource;
        this.$cookies = $cookies;
        this.$window = $window;
        this.accountService = accountService;
        this.userProfile = this.$cookies.get('reece-user-profile');
        this.userLocation = this.$cookies.get('reece-user-location');
    }

    retrieveViewCartModel() {
        var userStateCode = this.getUserStateCode();
        var request =  {
            stateCode: userStateCode
        };

        if(!userStateCode) {
            var emptyCart = this.createEmptyCart();
            return this.$q(function(resolve){resolve(emptyCart)});
        }

        var Cart = this.$resource('/bathrooms/cart/public/service/carts/retrieve', {}, {
            'viewCart': {
                method: 'GET',
                headers: {'origin_company_id': this.$window.companyIdentifier}
            }
        });

        return Cart.viewCart(request).$promise;
    }

    createEmptyCart() {
        return {
            products: [],
            subTotal: 0,
            totalGst: 0
        }
    }

    canViewCart() {

        if(this.accountService.isTradeUser()) {
            return false;
        }

        return true;
    }

    updateCartItemQuantity(product) {
        var self = this;
        return this.$q(function (resolve, reject) {
            window.CART.fn.updateItem({
                updateItem: {
                    productCode: product.productCode,
                    quantity: parseFloat(product.quantity),
                    pack: product.pack,
                    quoteId: product.quoteId ? product.quoteId : null,
                    lineId: product.lineId ? product.lineId : null
                }
            }, function () {
                resolve();
            }, function (status, error) {
                reject({ status: status, error: error });
            })
        })
    }

    removeCartItem(product) {
        var self = this;
        return this.$q(function (resolve, reject) {
            window.CART.fn.removeItem({
                deleteItem: {
                    productCode: product.productCode,
                    pack: product.pack,
                    quoteId: product.quoteId ? product.quoteId : null,
                    lineId: product.lineId ? product.lineId : null
                }
            }, function () {
                resolve();
            }, function (status, error) {
                reject({ status: status, error: error });
            })
        })
    }

    getUserStateCode() {
        var userProfile = this.userProfile ? JSON.parse(this.userProfile) : null;

        return (userProfile && userProfile.pricingState) ? userProfile.pricingState : this.getStateFromLocationCookie();
    };

    getStateFromLocationCookie() {
        var userLocation = this.userLocation ? JSON.parse(this.userLocation): null;

        return (userLocation && userLocation.state) ? userLocation.state : null;
    };
}

export default CartService;



// WEBPACK FOOTER //
// ./src/app/services/cart-service.js